import { useState } from "react";
import { fr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const versIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const ChampDate = ({ valeur, onChange, testId }) => {
  const [ouvert, setOuvert] = useState(false);
  const date = valeur ? new Date(`${valeur}T12:00:00`) : undefined;
  return (
    <Popover open={ouvert} onOpenChange={setOuvert}>
      <PopoverTrigger asChild>
        <button type="button" className="at-input flex items-center justify-between text-left" data-testid={testId}>
          <span style={{ color: date ? "var(--ink)" : "var(--muted)" }}>{date ? date.toLocaleDateString("fr-FR") : "jj/mm/aaaa"}</span>
          <CalendarDays size={16} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="at-popover w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={date} defaultMonth={date} onSelect={(d) => { onChange(d ? versIso(d) : ""); setOuvert(false); }} />
        {date && <button type="button" className="at-btn w-full" onClick={() => { onChange(""); setOuvert(false); }} data-testid={`${testId}-effacer`}>Effacer</button>}
      </PopoverContent>
    </Popover>
  );
};
